import React from "react";
import RSLogo from "../../components/icons/RSLogo";
import { Button } from "../../components/ui";
import { ToggleSwitch } from "../../components/ui";
import { Tooltip } from "../../components/ui";
import { UserPortal } from "../../components/ui";
import { TimePicker } from "../../components/ui";
import { IconText } from "../../components/ui";

/**
 * DevShoppingMall component renders a showcase of various reusable UI components and
 * logos. Reachable through the /shopping address. Please add a showcase of each new
 * component created in the project here. If you update an existing component, please
 * update it here and ensure it still works wherever else it is used in the project.
 *
 * We absolutely expect existing components to be expanded with more options/features
 * and for many new components to be added as the project progresses.
 *
 * @component
 * @returns {JSX.Element} Component showcase page.
 */
const DevShoppingMall = () => {
  return (
    <div className="w-screen p-2 bg-custom-rsbg">
      <div className="m-2 text-lg font-bold">
        Developer Reusable Component Shopping Mall
      </div>
      <div className="m-2 text-md font-bold">UI Components</div>
      <div className="m-2 w-60 flex flex-row justify-between">
        <Button text="Button Primary" variant="primary" />
        <Button text="Button Secondary" variant="secondary" />
      </div>
      <div className="m-2 w-60 flex flex-row justify-between">
        <ToggleSwitch text={"toggle switch"} />
      </div>
      <div className="m-2 w-60 flex flex-row justify-between hover:cursor-pointer group/tooltip">
        <p className="text-blue-700">Tootlip (hover)</p>
        <div className="tooltip relative top-0 origin-top group-hover/tooltip:scale-100">
          <Tooltip text={"Tooltip text"} />
        </div>
      </div>
      <div className="m-2 w-60 flex flex-row justify-between">
        <p className="text-blue-700">User portal: </p>
        <UserPortal text="JC" />
      </div>
      <div>
        <TimePicker />
      </div>
      <div className="mt-2">
        <IconText icon="location" text="Text next to icon" />
      </div>
      <div className="m-2 text-md font-bold">Logos</div>
      <div className="flex flex-row bg-gray-400 p-4">
        <RSLogo classes="h-10 mx-4" variant={"logo_trans_white"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_trans_fill_white"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_dark_trans_fill_white"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_trans"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_white_fill"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_with_text_trans"} />
        <RSLogo classes="h-10 mx-4" variant={"logo_with_text_white_fill"} />
      </div>
    </div>
  );
};

export default DevShoppingMall;
